import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { register } from '../../modules/agent';
import CountryDropdown from '../../components/CountryDropdown';

class Registration extends Component {
  state = {
    registrationData: {
			agencyName: '',
			//agencyCode: '',
			agencyAddressLine1: '',
			agencyAddressLine2: '',
			agencyCity: '',
			agencyState: '',
			agencyZip: '',
			agencyCountry: '',
			agencyPhone: '',

			agentFirstName: '',
			agentLastName: '',
			agentEmail: '',
			agentPassword: '',
			agentConfirmPassword: '',
		},

		errorMessage: '',
  };

  handleChange = (e) => {
    e.stopPropagation();
    e.preventDefault();
	const { name, value } = e.currentTarget;
	let newValue = value;

	if (name === 'agencyZip') {
		newValue = newValue.slice(0, 6);
	}

    const { registrationData } = this.state;
    registrationData[name] = newValue;
    this.setState(Object.assign(this.state, { registrationData }));
  };

  validatePasswd = password => {
	  var capital = /[A-Z]/g;
	  var digits = /[0-9]/g;
	  if (!password.match(capital) || !password.match(digits) || password.length<8)
		  return false;
		return true;
  }

  handleSubmit = (e) => {
    e.stopPropagation();
	e.preventDefault();

	const { registrationData: {
		agencyName,
		//agencyCode,
		agencyAddressLine1,
		agencyAddressLine2,
		agencyCity,
		agencyState,
		agencyCountry,
		agencyZip,
		agencyPhone,

		agentFirstName,
		agentLastName,
		agentEmail,
		agentPassword,
		agentConfirmPassword,
	}, errorMessage } = this.state;

	if (errorMessage) {
		this.setState(Object.assign(this.state, {
			errorMessage: ''
		}));
	}

	if (!this.validatePasswd(agentPassword)) {
		console.log('Your password must contain at least one capital letter and one number');
		this.setState(Object.assign(this.state, {
			errorMessage: 'Your password must contain at least 8 characters, one capital letter and one number'
		}));
		return;
	}

	if (agentConfirmPassword !== agentPassword) {
		this.setState(Object.assign(this.state, {
			errorMessage: 'Password and Confirm Password must match'
		}));
		return;
	}

	const accountDetails = {
		agencyName,
		addressLine1: agencyAddressLine1,
		addressLine2: agencyAddressLine2,
		city: agencyCity,
		state: agencyState,
		country: agencyCountry,
		zipcode: agencyZip,
		//code: agencyCode,
		phoneNumber: agencyPhone,

		firstName: agentFirstName,
		lastName: agentLastName,
		email: agentEmail,
		password: agentPassword
	};

    const { register, history: { push } } = this.props;
    register(accountDetails)
      .then(() => push('/'))
      .catch(e => {
		const error = e.response && e.response.data && e.response.data.error;

        this.setState(Object.assign(this.state, {
          errorMessage: (error && error.message) ||'Registration Failed'
        }));
	  });
  };

  render() {
    const { registrationData, errorMessage } = this.state;

    return (
      <div className="my-4">

        <Container>
          <div>
            <style>{'body { background-image: url(/static/media/registration-page.jpeg); background-repeat: no-repeat; background-size: cover;  }'}</style>
          </div>
          <Row className="justify-content-center">
            <Col md="6">
              <Card className="mx-4">
								<CardBody className="p-4">
									<Form onSubmit={this.handleSubmit}>
										<Row>
											<Col>
												<h2>Agency Details</h2>
												<p className="text-muted">Agency related information</p>
												<p>Agency name</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="icon-user" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="text"
														placeholder="Name"
														name="agencyName"
														value={registrationData.agencyName}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>

												<p>Address 1</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="icon-location-pin" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="text"
														placeholder="Address Line 1"
														name="agencyAddressLine1"
														value={registrationData.agencyAddressLine1}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
												<p>Address 2</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="icon-location-pin" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="text"
														placeholder="Address Line 2"
														name="agencyAddressLine2"
														value={registrationData.agencyAddressLine2}
														onChange={this.handleChange}
													/>
												</InputGroup>
												<p>Country</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="fa fa-building-o" />
														</InputGroupText>
													</InputGroupAddon>
													<CountryDropdown
														placeholder="Country"
														name="agencyCountry"
														value={registrationData.agencyCountry}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
												<p>State</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="fa fa-building-o" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="text"
														placeholder="State"
														name="agencyState"
														value={registrationData.agencyState}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
												<p>City</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="fa fa-building-o" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="text"
														placeholder="City"
														name="agencyCity"
														value={registrationData.agencyCity}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
												<p>Zipcode</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="fa fa-building-o" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="text"
														placeholder="Zipcode"
														name="agencyZip"
														size="6"
														value={registrationData.agencyZip}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
												<p>Phone number</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="icon-phone" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="text"
														placeholder="Phone"
														name="agencyPhone"
														value={registrationData.agencyPhone}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
											</Col>
										</Row>

										<Row className="my-3">
											<Col>
												<h2>Agent Details</h2>
												<p className="text-muted">Agent related information</p>
												<p>Agent first name</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="icon-user" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="text"
														placeholder="First Name"
														name="agentFirstName"
														value={registrationData.agentFirstName}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
												<p>Agent last name</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="icon-user" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="text"
														placeholder="Last Name"
														name="agentLastName"
														value={registrationData.agentLastName}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
												<p>Agent email</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>@</InputGroupText>
													</InputGroupAddon>
													<Input
														type="email"
														placeholder="Email"
														name="agentEmail"
														value={registrationData.agentEmail}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
												<p>Password</p>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="icon-lock" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="password"
														placeholder="Password"
														name="agentPassword"
														value={registrationData.agentPassword}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
												<p>confirm password</p>
												<InputGroup className="mb-4">
													<InputGroupAddon addonType="prepend">
														<InputGroupText>
															<i className="icon-lock" />
														</InputGroupText>
													</InputGroupAddon>
													<Input
														type="password"
														placeholder="Repeat Password"
														name="agentConfirmPassword"
														value={registrationData.agentConfirmPassword}
														onChange={this.handleChange}
														required
													/>
												</InputGroup>
											</Col>
										</Row>

										{
											!!errorMessage && (
												<Row>
													<Col>
														<div className="alert alert-danger" role="alert">
															{ errorMessage }
														</div>
													</Col>
												</Row>
											)
										}

										<Row className="mt-3">
											<Col>
												<Button color="success" type="submit" block>Create Account</Button>
												<Link className="link-button" style={{ padding: 10 }} to="/login"><Button color="primary" block>Already have an Account? Log in</Button></Link>
											</Col>
										</Row>
									</Form>
								</CardBody>
              </Card>
            </Col>
					</Row>
        </Container>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  register,
}, dispatch);

export default connect(
  null,
  mapDispatchToProps,
)(Registration);



// WEBPACK FOOTER //
// ./src/containers/Registration/Registration.js